module.exports = __webpack_public_path__ + "static/media/ico-tus-contactos-inact.e69c86f0.svg";